import { createSlice } from "@reduxjs/toolkit";
import { RootState } from "src/lib/store/store";
import { AuthState, SessionExpiredReason } from "./auth.type";

const initialState: AuthState = {
  user: null,
  token: null,
  accessToken: null,
  refreshToken: null,
  isAuthenticated: false,
  sessionExpiredReason: null,
};

const slice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    logout: () => {
      return initialState;
    },
    addUserProfile: (state, { payload }) => {
      state.accessToken = payload.accessToken;
      state.refreshToken = payload.refreshToken ?? state.refreshToken;
      state.isAuthenticated = true;
      state.user = payload.user;
      state.sessionExpiredReason = null;
    },
    /* Applied after a successful refresh. Deliberately leaves `user` alone --
       the profile is unchanged, and re-rendering it would flicker the UI
       under a refresh the user is not supposed to notice. */
    setTokens: (
      state,
      { payload }: { payload: { accessToken: string; refreshToken: string } }
    ) => {
      state.accessToken = payload.accessToken;
      state.refreshToken = payload.refreshToken;
      state.isAuthenticated = true;
      state.sessionExpiredReason = null;
    },
    /* Clears credentials but keeps the app mounted and records why, so the
       modal can explain itself. Distinct from `logout`, which resets the
       reason and is only dispatched on the way out the door. */
    sessionExpired: (
      state,
      { payload }: { payload: SessionExpiredReason }
    ) => {
      state.token = null;
      state.accessToken = null;
      state.refreshToken = null;
      state.isAuthenticated = false;
      state.sessionExpiredReason = payload;
    },
  },
});

export const { logout, addUserProfile, setTokens, sessionExpired } =
  slice.actions;
export default slice.reducer;

export const selectUserState: (state: RootState) => AuthState = (
  state: RootState
) => state.auth;
